export default {
  retail: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Retail & hospitality',
    hero: {
      eyebrow: 'Retail & hospitality',
      title: 'More security in shops and hospitality',
      lead: 'Entrance, checkout zone, warehouse and kitchen access – we protect your business from theft and vandalism without disturbing your customers.',
    },
    points: {
      title: 'Surveillance points for retail and hospitality',
      lead: 'Every shop and hospitality business has its own risk areas. We place the cameras exactly where they make a difference.',
      items: {
        '0': { title: 'Entrance & shop window', desc: 'The first surveillance point: cameras at the entrance document who comes and goes – and deter from the moment of entry.' },
        '1': { title: 'Checkout zone', desc: 'The till and payment area are the most sensitive point in retail. Discreet cameras secure the area without unsettling customers.' },
        '2': { title: 'Sales floor', desc: 'Overview of the whole area: wide-angle cameras detect suspicious movement in shelf areas and side aisles.' },
        '3': { title: 'Warehouse & deliveries', desc: 'Goods reception, warehouse and staff access: gaps appear when goods arrive or leave. We close them.' },
        '4': { title: 'Counter & kitchen access', desc: 'In hospitality, the counter and kitchen access are critical areas. Robust cameras withstand humidity and heat.' },
        '5': { title: 'Outdoor seating & terrace', desc: 'Terraces and outdoor seating invite opportunists, especially in the evening. Weatherproof cameras keep watch.' },
      },
    },
    protection: {
      eyebrow: 'Theft protection',
      title: 'Less inventory shrinkage, more security',
      lead: 'Shoplifting and inventory discrepancies cost retail significant sums every year. Well-placed cameras demonstrably reduce losses – and provide usable footage when needed.',
      items: {
        '0': { title: 'Checkout-zone monitoring', desc: 'Sharp images of the till and payment area – for complete documentation in disputes and manipulation.' },
        '1': { title: 'Shop windows & access', desc: 'Deterrence and clarification in case of vandalism or burglary – from the shop window to the back entrance.' },
        '2': { title: 'Event logs', desc: 'Movement, line crossing or door events trigger recording and push notifications – exactly when relevant.' },
      },
    },
    gastro: {
      eyebrow: 'Hospitality',
      title: 'Robust technology for counter, kitchen and terrace',
      lead: 'Steam, grease and humidity place special demands on the technology. We choose cameras that work reliably in everyday hospitality – and that guests do not notice.',
      list: {
        '0': 'Monitor kitchen access – only authorised staff have entry',
        '1': 'Secure counter and checkout area without disturbing guests',
        '2': 'Keep outdoor seating and terrace in view in the evening',
        '3': 'Document suppliers and deliveries completely',
        '4': 'Add signage for guests and staff',
      },
      note: 'Note: The legal admissibility of video surveillance depends on the individual case. We advise you, but do not replace legal advice.',
    },
    cta: {
      title: 'Your business deserves a secure framework',
      lead: 'We show you, without obligation, where video surveillance pays off for you – and where it is not needed.',
      primary: 'Arrange a consultation',
      secondary: 'Discover SSG Care',
    },
  },
};